import mapaDeRotas from "@/router/caminho-urls";
import {getTokenAuth} from "@/stores/auth";

export async function AlteraSenha(dados) {
    const isDevEnvironment = process.env.VUE_APP_NODE_ENV === "development";
    const token_base = isDevEnvironment ? getTokenAuth() : null;
    const caminho = new mapaDeRotas();

    const formData = new FormData();
    for (const key in dados) {
        formData.append(key, dados[key]);
    }

    const headers = {};
    if (token_base) {
        headers["Authorization"] = token_base;
    }

    try {
        const response = await fetch(`${caminho.rota_api}/usuario/salva-senha`, {
            method: 'POST',
            body: formData,
            headers: headers
        });

        const data = await response.json();

        if (!response.ok) {
            console.error('Erro na requisição:', data);
            return {erro: 1, mensagem: "Erro ao alterar a senha"};
        }

        return data;
    } catch (err) {
        console.error('Erro de conexão:', err);
        return {erro: 1, mensagem: "Erro de conexão com o servidor"};
    }
}
